import { render, staticRenderFns } from "./ContractualInformation.vue?vue&type=template&id=e96cb53a&scoped=true"
import script from "./ContractualInformation.vue?vue&type=script&lang=ts"
export * from "./ContractualInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96cb53a",
  null
  
)

export default component.exports